import { orderMapper } from "~/assets/js/utils";
import { EVOLUTION_RANGE } from "~/constants/version";
import { toAgentsPerVersionEvolution } from "~/transformers/dashboardTransformer";

export default {
  async fetch({ dispatch, commit, rootGetters }) {
    commit("SET_LOADING", true);
    try {
      commit("RESET_OPEN_AGENCIES");
      const instanceId = rootGetters["application/getMainInstanceId"];
      commit("SET_INSTANCE_ID", instanceId);

      await dispatch("setVersions");
      await dispatch("updateEvolutionStats", EVOLUTION_RANGE.LAST_7);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async setVersions({ commit, state, rootGetters }) {
    const { page, sortBy, orderBy, search: filter } = state;
    const size = rootGetters["application/getPageSize"];
    try {
      const versions = await this.$services.version.fetchVersions(state.instanceId, {
        size,
        page,
        sortBy,
        orderBy,
        filter,
      });
      commit("SET_VERSIONS", versions);
    } catch (error) {
      throw error;
    }
  },

  async fetchAgenciesByVersion({ commit, state }, { versionId, requestParams }) {
    const { page, sortBy, orderBy } = requestParams;

    let { size } = requestParams;
    if (size === undefined) {
      size = 10;
    }

    try {
      const agencies = await this.$services.version.fetchAgenciesByVersion(
        state.instanceId,
        versionId,
        { size, page, sortBy, orderBy: orderMapper(orderBy) },
      );

      commit("SET_AGENCIES", { parent: versionId, agencies: { ...agencies, sortBy, orderBy } });
    } catch (error) {
      throw error;
    }
  },

  async removeAgencies({ commit }, versionId) {
    commit("REMOVE_AGENCIES", { parent: versionId });
  },

  async updateEvolutionStats({ commit, rootGetters }, range) {
    const { agencyId } = rootGetters["application/getSelectedAgency"];
    const stats = await this.$services.version.fetchEvolutionStats(range, agencyId);

    commit("SET_VERSIONS_PER_AGENT_EVOLUTION_STATS", toAgentsPerVersionEvolution(stats));
  },

  async updateAgentsPerVersionEvolutionStats({ commit }, range) {
    const stats = await this.$services.version.fetchEvolutionStats(range);

    commit("SET_VERSIONS_PER_AGENT_EVOLUTION_STATS", toAgentsPerVersionEvolution(stats));
  },

  async prepareCsv({ commit, dispatch, state }, { version, requestParams = {} }) {
    try {
      await this.$services.version.preparecsv(state.instanceId, version, requestParams);
      await dispatch("application/setDownloads", {}, { root: true });
      commit("application/SET_IS_WAITING_FOR_DOWNLOADS", true, { root: true });
      this.$feedback.ok("generic.download.ok");
    } catch {
      this.$feedback.error("generic.download.error");
    }
  },
};
